// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "code/chunk-" + {"64":"subapps/onboarding","266":"subapps/kb","757":"subapps/chat","825":"subapps/settings"}[chunkId] + "." + {"64":"09bb6c5e9c505b7f2ebc","266":"360d5fb65f660ebc722f","757":"cb6ee63e1b4dce73e9fe","825":"e5504bcaf233caad18e9"}[chunkId] + ".css";
};